import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../../utils/TableTimestamps';
import {NavLink} from 'react-router-dom';
import {AccountApplication} from '../types';

export const columns = [
    {
        title: I18n.get('Name'),
        width: '1fr',
        // FNP-2070: ids are `${accountId}#${applicationId}` (FNP-902); unencoded,
        // the `#` starts a URL fragment and the edit page gets half the id.
        render: (item: AccountApplication) => <NavLink to={`/account-applications/${encodeURIComponent(item.id)}`}>{item.application?.name}</NavLink>,
    },
    {
        title: I18n.get('App Link'),
        width: '1fr',
        render: (item: AccountApplication) => item.application?.url,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: AccountApplication) => formatTimestamp(item.created),
    },
];
